import { Avatar, ListItemAvatar, ListItem, ListItemButton, ListItemText, Tabs, Tab } from "@mui/material";
import axios from "axios";
import { useEffect, useRef, useState } from "react";
import LoadingSpinner from "../../../../sharedComponents/LoadingSpinner/LoadingSpinner";
import "./Absences.css";
import { FixedSizeList } from "react-window";
import EventNoteIcon from '@mui/icons-material/EventNote';
import HistoryIcon from '@mui/icons-material/History';
import BeachAccessIcon from '@mui/icons-material/BeachAccess';
import { Link } from "react-router-dom";
import PrimaryButton from "../../../../sharedComponents/primaryButton/PrimaryButton";
import { MonthNames } from "../../../../sharedComponents/MonthNames";

function Absences() {

    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);

    const [selectedTab, setSelectedTab] = useState(1);
    
    const [absences, setAbsences] = useState([]);

    const [currentYear, setCurrentYear] = useState(null);
    const [currentMonth, setCurrentMonth] = useState(null);
    const [lastYear, setLastYear] = useState(null);
    const [lastMonth, setLastMonth] = useState(null);
    const latestRequestId = useRef(0);

    useEffect(() => {
        const currentDate = new Date();
        setCurrentYear(currentDate.getFullYear());
        setCurrentMonth((currentDate.getMonth() + 1).toString().padStart(2, '0'));

        const lastMonthDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1);
        setLastYear(lastMonthDate.getFullYear());
        setLastMonth((lastMonthDate.getMonth() + 1).toString().padStart(2, '0'));
    }, [])

    useEffect(() => {
        if (currentYear && currentMonth && lastYear && lastMonth) {
            if (selectedTab === 0) {
                getAbsencesForMonth(lastYear, lastMonth);
            } else if (selectedTab === 1) {
                getAbsencesForMonth(currentYear, currentMonth);
            }
        }
    }, [currentYear, currentMonth, lastYear, lastMonth, selectedTab]);

    function getAbsencesForMonth(year, month) {
        const requestId = ++latestRequestId.current;
        setHasError(false);
        setIsLoading(true);
        axios.get(`absence/getAbsencePeriodsForAllEmployees?year=${year}&month=${month}`).then(results => {
            if (requestId !== latestRequestId.current) return;
            setAbsences(results.data || []);
            setIsLoading(false);
        }).catch(() => {
            if (requestId !== latestRequestId.current) return;
            setHasError(true);
            setIsLoading(false);
        })
    }

    const changeTab = () => {
        if (selectedTab === 0)
            setSelectedTab(1);
        else
            setSelectedTab(0);
    }

    const handleEmployeeAbsenceClick = (absenceType) => {
        sessionStorage.setItem("currentNavItem", "employees");
        if (absenceType === "Feiertag") {
            sessionStorage.setItem("emplyoeeViewIndex", "4");
        } else {
            sessionStorage.setItem("emplyoeeViewIndex", "1");
        }
    }

    function generateCurrentMonthAbsenceItems(props) {
        const { index, style } = props;

        const flattenedAbsences = absences.flatMap(absence =>
            (absence.absencePeriods || []).map(period => ({
                ...period,
                employeeFirstName: absence.employeeFirstName,
                employeeLastName: absence.employeeLastName,
                employeeId: absence.employeeId,
            }))
        )
        
        const sortedAbsences = flattenedAbsences.sort((a, b) => new Date(a.absenceDays[0].date) - new Date(b.absenceDays[0].date));
        const absence = sortedAbsences[index];
        const absenceDays = absence.absenceDays.sort((a, b) => new Date(a.date) - new Date(b.date));

        return (
            <Link to={'/home/employees/employeeView?employeeId=' + absence.employeeId} onClick={() => handleEmployeeAbsenceClick(absence.absenceType)}>
                <ListItem style={style} key={index} component="div" disablePadding>
                <ListItemButton>
                    <ListItemAvatar>
                        <Avatar>
                            <BeachAccessIcon />
                        </Avatar>
                    </ListItemAvatar>
                    <ListItemText primary={absence.employeeFirstName + " " + absence.employeeLastName + " (" + absence.absenceType + ")"} secondary={generateSecondaryTextForAbsences(absenceDays)} />
                </ListItemButton>
                </ListItem>
            </Link> 
        )
    }

    function generateSecondaryTextForAbsences(absenceDays) {
        if (absenceDays[0].ignoreSpecificDate) {
            return "Kein Datum angegeben";
        } else {
            const startDate = new Date(absenceDays[0].date).toLocaleDateString("de-DE", { day: '2-digit', month: '2-digit', year: 'numeric' });
            const endDate = new Date(absenceDays[absenceDays.length - 1].date).toLocaleDateString("de-DE", { day: '2-digit', month: '2-digit', year: 'numeric' });

            if (startDate === endDate) {
                return `${startDate}`;
            }

            return `${startDate} - ${endDate}`;
        }
    }

    return (
        <div className="absence-container">
            <div className="absence-header">
                <div className="horizontal-header">
                    <h3>Abwesenheiten</h3>
                    <Link to={"absences/"}>
                        <PrimaryButton text="Alle Abwesenheiten"/>
                    </Link>
                </div>
                <Tabs onChange={changeTab} value={selectedTab} >
                    <Tab icon={<HistoryIcon />} iconPosition="start" label={"Letzter Monat (" + MonthNames[new Date().getMonth() - 1] + ")"} />
                    <Tab icon={<EventNoteIcon />} iconPosition="start" label={"Aktueller Monat (" + MonthNames[new Date().getMonth()] + ")"} />
                </Tabs>
            </div>

            {isLoading ?
                <LoadingSpinner />
                :
                hasError ?
                    <p>Ein Fehler ist aufgetreten</p>
                    :
                    <FixedSizeList
                        height={400}
                        width={"90%"}
                        itemSize={60}
                        itemCount={absences.flatMap(absence => absence.absencePeriods || []).length}
                        overscanCount={20}>
                        {generateCurrentMonthAbsenceItems}
                    </FixedSizeList>
            }
        </div>
    )
}

export default Absences;